export default __webpack_public_path__ + "static/layout-dont-light-28853a8088396b78510ed64ff137f940.png";